import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  TooltipPortal,
} from '../../../../containers/Tooltip';
import { Button } from '../../../Button/Button';
import { ButtonCopy } from '../../../Button/ButtonCopy';
import { ButtonGroup } from '../../../Button/ButtonGroup';

type ToolbarMinimalProps = {
  className?: string;
  clear: () => void;
  redraw: () => void;
  smiles: string;
};
export function ToolbarMinimal(props: ToolbarMinimalProps) {
  const { className, clear, redraw, smiles } = props;

  const spaceIsEmpty = !smiles;

  const items = [
    {
      name: 'Clean up',
      icon: 'auto_fix_normal',
      onClick: redraw,
    },
    {
      name: 'Reset',
      icon: 'delete',
      onClick: clear,
    },
  ];

  return (
    <ButtonGroup className={className}>
      {items.map(item => (
        <TooltipProvider key={item.name}>
          <Tooltip delayDuration={300}>
            <Button
              as={TooltipTrigger}
              weight="minimal"
              size="small"
              icon={item.icon}
              onClick={item.onClick}
              disabled={spaceIsEmpty}
            />
            <TooltipPortal>
              <TooltipContent>
                {item.name}
                <TooltipArrow />
              </TooltipContent>
            </TooltipPortal>
          </Tooltip>
        </TooltipProvider>
      ))}
      <ButtonCopy weight="minimal" size="small" copy={smiles} disabled={spaceIsEmpty} />
    </ButtonGroup>
  );
}
